var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneCut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5303 1.46967C22.8232 1.76256 22.8232 2.23744 22.5303 2.53033L2.53033 22.5303C2.23744 22.8232 1.76256 22.8232 1.46967 22.5303C1.17678 22.2374 1.17678 21.7626 1.46967 21.4697L21.4697 1.46967C21.7626 1.17678 22.2374 1.17678 22.5303 1.46967Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.48846 17.6935C12.7216 20.3256 15.5296 20.9322 17.2532 20.998C18.4299 21.0429 19.4246 20.319 20.0934 19.3499L20.4567 18.8235C21.4501 17.384 21.0409 15.4065 19.5578 14.4796L18.0721 13.551C17.1862 12.9973 16.0224 13.2284 15.4152 14.0785C14.948 14.7325 14.2274 15.1967 13.4506 14.99C13.1798 14.918 12.8732 14.808 12.5396 14.6423L9.48846 17.6935Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.35767 11.4604L6.30651 14.5115C3.67439 11.2784 3.06776 8.47038 3.00198 6.7468C2.95708 5.57013 3.68099 4.57544 4.65013 3.9066L5.17653 3.5433C6.616 2.54986 8.59347 2.95907 9.52045 4.44223L10.449 5.92785C11.0027 6.81377 10.7716 7.97756 9.9215 8.58479C9.26746 9.05196 8.80326 9.77263 9.00997 10.5494C9.08205 10.8202 9.192 11.1268 9.35767 11.4604Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneCut);
export default __webpack_public_path__ + "static/media/phone-cut.29cbcc0ff85c147a9dc030c2ab1db7f6.svg";
export { ForwardRef as ReactComponent };